import { g as __rest, b as __assign } from '../../../../../_tslib-7a01aab4.js';
import React from 'react';

var SettingButton = function (_a) {
    var children = _a.children, iconName = _a.iconName, isActive = _a.isActive, isDisabled = _a.isDisabled, videoClassName = _a.videoClassName, _b = _a.isShowIcon, isShowIcon = _b === void 0 ? true : _b, forFreeBets = _a.forFreeBets, forPlatformSideBar = _a.forPlatformSideBar, rest = __rest(_a, ["children", "iconName", "isActive", "isDisabled", "videoClassName", "isShowIcon", "forFreeBets", "forPlatformSideBar"]);
    return (React.createElement("div", __assign({ className: "pgc-settings-tab ".concat(isActive ? 'active' : '', "  ").concat(isDisabled ? 'disabled' : '', "  ").concat(videoClassName || '', " ").concat(forFreeBets ? 'free-bets-table' : '', " ").concat(forPlatformSideBar ? 'platform-side-bar' : '') }, rest),
        React.createElement("div", { className: 'pgc-settings-inner' },
            isShowIcon && React.createElement("i", { className: "icon-".concat(iconName) }),
            children)));
};

export { SettingButton };
